'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Store all of our reusable constants here

// Adswizz tracking scripts
var ADSWIZZ_SYNCHROBOX_SCRIPT = exports.ADSWIZZ_SYNCHROBOX_SCRIPT = 'https://synchrobox.adswizz.com/register2.php';

var ADSWIZZ_SYNCHROCLIENT_SCRIPT = exports.ADSWIZZ_SYNCHROCLIENT_SCRIPT = 'https://delivery-cdn-cf.adswizz.com/adswizz/js/SynchroClient2.js';

// Adswizz GDPR consent parameter
var ADSWIZZ_GDPR_CONSENT_PARAMETER = exports.ADSWIZZ_GDPR_CONSENT_PARAMETER = 'aw_0_req.gdpr';

// Adswizz IAB TCF V2 parameter
var ADSWIZZ_GDPR_TCFV2_TCSTRING_PARAMETER = exports.ADSWIZZ_GDPR_TCFV2_TCSTRING_PARAMETER = 'aw_0_req.userConsentV2';

// Adswizz Request Url
var ADSWIZZ_REQUEST_URL = exports.ADSWIZZ_REQUEST_URL = 'https://tunein.deliveryengine.adswizz.com/www/delivery/swfIndex.php';

// DFP GDPR query param. See "Simple URLs" header here:
// https://support.google.com/admanager/answer/7678538?vid=0-382140149630-1547151546809
var DFP_GDPR_NON_PERSONALIZED_ADS_PARAMETER = exports.DFP_GDPR_NON_PERSONALIZED_ADS_PARAMETER = 'npa';

// Programmatic Ads Libraries
var PAL_SCRIPT = exports.PAL_SCRIPT = '//imasdk.googleapis.com/pal/sdkloader/pal.js';
var PAL_SCRIPT_ID = exports.PAL_SCRIPT_ID = 'PAL_SCRIPT_ID';

// Player Url's
var IMA_PLAYER_SCRIPT = exports.IMA_PLAYER_SCRIPT = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
var IMA_SCRIPT_LOAD_EVENT_TYPE = exports.IMA_SCRIPT_LOAD_EVENT_TYPE = 'load';
var IMA_VIDEO_PLAYER_ID = exports.IMA_VIDEO_PLAYER_ID = 'imaPlayer';
var IMA_PLAYER_SCRIPT_ID = exports.IMA_PLAYER_SCRIPT_ID = 'imaSdkScript';